import React from 'react';

const Footer = () => {
    return (
        <div className='about-container text-white text-center p-5 fw-400 fs-6'  >
            Jannatul Ferdous Happy &copy All Right Reserved!
        </div>
    );
};

export default Footer